import styled from 'styled-components'

export const Notes = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['4'],
}))

export const SecretText = styled.span(() => ({
  minWidth: 0,
  overflowWrap: 'anywhere',
}))
